import { useEffect, useRef, useState } from "react";

export const useStylePropertyVariableValueFromParent = (
    cssVariableName: string
): [React.RefObject<HTMLElement>, string | undefined] => {
    const ref = useRef<HTMLElement>(null);
    const [propertyValue, setPropertyValue] = useState<string | undefined>();

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        let element: HTMLElement | null = ref.current;
        let depth = 0;
        const maxDepth = 20; // prevent infinite loops

        while (element && depth < maxDepth) {
            const computedStyle = getComputedStyle(element);
            const value = computedStyle
                .getPropertyValue(cssVariableName)
                .trim();

            if (value && value !== "") {
                setPropertyValue(value);
                return;
            }

            element = element.parentElement;
            depth++;
        }

        setPropertyValue(undefined);
    }, [cssVariableName]);

    return [ref, propertyValue];
};
